/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Latest action point performed
 */
export type ActionPoints = (typeof ActionPoints)[keyof typeof ActionPoints];

export const ActionPoints = {
  REBOOT: 'reboot',
} as const;
